function mbProdSlider() {
  var numItems = $('.visible_cell').length;

  // Show the slider bullets container if there's at least one item.
  if (numItems >= 1) {
    $(".slider_bullets").show();
  }

  // Handle the visibility of individual bullets.
  $(".slider_bullet").each(function(index) {
    if (index < numItems) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });

  // Function to update the active bullet indicator.
  var updateActiveBullet = function(scrollPercentage, mediaCount) {
    var scrollBreakpoint = 100 / mediaCount;
    var activeBulletIndex = Math.ceil(scrollPercentage / scrollBreakpoint);
    // Reset to the first bullet if we're at the start (scrollPercentage is 0).
    if (scrollPercentage === 0) {
      activeBulletIndex = 1;
    }
    $("#active_bullet").val(activeBulletIndex.toString());

    // Update bullet backgrounds based on the active bullet.
    $(".slider_bullet").css("background", "none");
    $("#bullet_" + activeBulletIndex).css("background", "#101010");
  };

  // Set the first bullet as active when initializing.
  if ($(".carousel__viewport").scrollLeft() === 0) {
    $(".slider_bullet").css("background", "none");
    $("#bullet_1").css("background", "#101010");
    $("#active_bullet").val("1");
  }

  // Handle the scroll event of the carousel viewport.
  $(".carousel__viewport").scroll(function() {
    var scrollPercentage = 100 * $(this).scrollLeft() / (this.scrollWidth - this.clientWidth);
    var mediaCount = $(".carousel__viewport li:visible").length;

    updateActiveBullet(scrollPercentage, mediaCount);
  });
}